import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class AudienceAttachContentError extends CodedError {
  static get errorName() {
    return errorCodes.audienceAttachContentError.code;
  }

  constructor(message: string = errorCodes.audienceAttachContentError.message) {
    super(message);
    this.code = errorCodes.audienceAttachContentError.code;
    this.message = `${message} ${errorCodes.audienceAttachContentError.code}`;
    this.name = errorCodes.audienceAttachContentError.name;
    this.status = errorCodes.audienceAttachContentError.status;
  }
}
